import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { CustomButton, Icon } from '../../../components/common';
import { DRAW_MODE } from '../../../lib/constants';
const LassoControl = ({ drawMode, changeDrawMode }) => {
    return (_jsx(CustomButton, { onClick: changeDrawMode, color: drawMode === DRAW_MODE.CREATE ? 'green' : 'white', className: "py-3 border-2 border-black/25 rounded focus:ring-0 focus:ring-offset-0", children: _jsx(Icon, { icon: "lasso" }) }));
};
LassoControl.propTypes = {
    drawMode: PropTypes.number,
    changeDrawMode: PropTypes.func,
};
export default LassoControl;
